__turbopack_context__.v({
  "className": "IuxTyG_className",
  "variable": "IuxTyG_variable",
});
